import React from 'react'
import { IconsProps } from 'msp-integrations'

const ArrowUpFilledIcon = (props: IconsProps) => {
  return (
    <svg
      version='1.1'
      {...props}
      viewBox='0 0 9 5'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d="M4.5 0 9 5H0z" />
    </svg>
  )
}

export default ArrowUpFilledIcon
